import {
  GET_FINANCIAL_SUITABILITY,
  GET_FINANCIAL_SUITABILITY_ERROR,
  GET_FINANCIAL_SUITABILITY_SUCCESS
} from './FinancialSuitabilitySection.actions'

const financialSuitabilityState = {
  dni: '',
  error: undefined,
  lastDeclaredPeriod: -1,
  loading: true,
  orgSize: -1,
  orgSizeDetails: '',
  orgSizeLabel: ''
}

/**
 * The Financial Suitability Section reducer.
 */
const financialSuitabilityReducer = (state = financialSuitabilityState, { payload, type }) => {
  switch (type) {
    case GET_FINANCIAL_SUITABILITY: {
      return { ...state, loading: true }
    }
    case GET_FINANCIAL_SUITABILITY_SUCCESS: {
      return {
        ...state,
        loading: false,
        dni: payload.dni,
        lastDeclaredPeriod: payload.lastDeclaredPeriod,
        orgSize: payload.orgSize,
        orgSizeDetails: payload.orgSizeDetails,
        orgSizeLabel: payload.orgSizeLabel
      }
    }
    case GET_FINANCIAL_SUITABILITY_ERROR: {
      return {
        ...state,
        loading: false,
        dni: payload.dni,
        error: payload.error
      }
    }
    default: {
      return state
    }
  }
}

export default financialSuitabilityReducer
